import { render } from "./becometrainernow.vue?vue&type=template&id=aa26a7ee"
import script from "./becometrainernow.vue?vue&type=script&lang=js"
export * from "./becometrainernow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__